

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Card } from 'element-ui';
import PasswordEditModal from '@/components/modals/PasswordEdit.vue';

@Component({
  components: {
    PasswordEditModal,
    'el-card': Card,
    'el-button': Button
  }
})

export default class Password extends Vue {
  private showModal = false;
}
